  <template>
  <section>
    <div id="auth" class="container">
      <div v-if="customerNew" id="msg-new-customer" class="flex column">
        <h3>Seja Bem Vindo(a)!</h3>
        <p class="margin-top-m">
          Você acaba de adquirir a melhor plataforma de dashboards financeiros para marketing digital.
        </p>
        <p class="margin-top-m">
          Foi enviado para seu <b>e-mail</b> de compra o <b>login e senha</b> para entrar na plataforma!
        </p>
      </div>
      <section id="auth-content" class="box padding w-buttons install margin-top-m">
        <div id="logo" class="flex middle">
          <div>
            <img src="@/assets/img/icon.png" width="100" />
          </div>
          <div>
            <span>Parceiros</span>
            <h1>Papai Noel Vídeo</h1>
          </div>
        </div>

        <div v-if="false" class="flex middle column margin-top-l">
          <div class="button-google" @click="createLoginGoogleOauth2()">
            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Open+Sans" />
            <div class="google-btn">
              <div class="google-icon-wrapper">
                <img class="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>
              </div>
              <p class="btn-text"><b>Entrar com Google</b></p>
            </div>
          </div>
          <div v-if="false" class="button-fb  margin-top-s" @click="createLoginFacebookOauth2()">
            <div class="loginBtn loginBtn--facebook">
              Entrar com Facebook
            </div>
          </div>
        </div>


        <form class="margin-top-l">
          <div class="item">
            <div class="flex between">
              <label>E-Mail</label>
            </div>
            <input v-model="email" type="email" placeholder="xxxxx@xxxx.com.br" />
          </div>

          <div class="item">
            <div class="flex between">
              <label>Senha</label>
              <span class="info"
                ><i class="fas fa-info-circle"></i
                ><router-link to="/recovery-password"
                  >Esqueceu sua senha?</router-link
                ></span
              >
            </div>

            <input v-model="password" type="password" placeholder="xxxxx" />
          </div>
        </form>



        <div class="buttons flex between middle">
          <a @click="login()" class="button primary" style="flex: 2" ref="buttonlogin">Entrar</a>
        </div>
      </section>
      <div class="txt-center margin-top-l">
        <router-link to="/register">Não tem Cadastro? <b>Criar Agora</b></router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { 
  login,
  checkIsLogged
} from "@/services/auth";
import {
  initFacebookLoginOauth2,
  initGoogleLoginOauth2,
} from "@/services/integration";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      customerNew: false,
      timerToRequest: 3000,
      detectTokenDataOauth: null,

    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    this.customerNew = params.get('customer_new')

    if (this.customerNew) {
      // fb event
      const fbq = window.fbq;
      if (fbq) {
        fbq("track", "Purchase", {});
      }
    }

    if (this.$route.query.d) {
      this.email = "demonstracao@lucreihoje.com.br";
      this.password = "demo1234";

      this.$refs.buttonlogin.click()
    }
  },
  methods: {
    login() {

      if (!this.email || !this.password) {
        this.$toast.error({
          title:'Erro',
          message:'Você deve preencher o email e senha para acessar'
        })

        return
      }

      let params = {
        username: this.email.trim(),
        password: this.password.trim()
      }

      login(params).then(
        (result) => {
          this.$store.dispatch("auth", { token: result.token });

          this.$router.push({ name: "Account" });
        }
      )
      .catch(() => {
        this.$toast.error({
          title:'Erro',
          message:'Usuário ou senha errados'
        })
      })
    },
    trackingEvents() {
      // fb event
      const fbq = window.fbq;
      if (fbq) {
        fbq("track", "Lead");
      }
    },
    checkIsLogged() {
      checkIsLogged()
        .then(() => {

          this.trackingEvents();

          clearInterval(this.detectTokenDataOauth)
          setTimeout(function() {
            location.reload(true);
          }, 1500)
        })
    },
    createLoginGoogleOauth2() {
      initGoogleLoginOauth2()
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.checkIsLogged(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
    createLoginFacebookOauth2() {
      initFacebookLoginOauth2()
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.checkIsLogged(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#logo {
  h1 {
    font-size: 34px;
  }
}
#msg-new-customer {
  padding: 32px;
  background: var(--secondary);
  border-radius: 5px;
  color: #000;
}



/* Shared */
.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 40px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #FFF;
  width:100%;
  text-align: center;
}
.loginBtn:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 100%;
}
.loginBtn:focus {
  outline: none;
}
.loginBtn:active {
  box-shadow: inset 0 0 0 32px rgba(0,0,0,0.1);
}


/* Facebook */
.loginBtn--facebook {
  background-color: #4C69BA;
  background-image: linear-gradient(#4C69BA, #3B55A0);
  /*font-family: "Helvetica neue", Helvetica Neue, Helvetica, Arial, sans-serif;*/
  text-shadow: 0 -1px 0 #354C8C;
}
.loginBtn--facebook:before {
  border-right: #364e92 1px solid;
  background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png') 6px 6px no-repeat;
}
.loginBtn--facebook:hover,
.loginBtn--facebook:focus {
  background-color: #5B7BD5;
  background-image: linear-gradient(#5B7BD5, #4864B1);
}


/* Google */
.loginBtn--google {
  /*font-family: "Roboto", Roboto, arial, sans-serif;*/
  background: #DD4B39;
}
.loginBtn--google:before {
  border-right: #BB3F30 1px solid;
  background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png') 6px 6px no-repeat;
}
.loginBtn--google:hover,
.loginBtn--google:focus {
  background: #E74B37;
}

.button-fb {
  cursor:pointer;
  width: 100%;

}

.button-google {
  cursor:pointer;
  width: 100%;

}


$white: #fff;
$google-blue: #4285f4;
$button-active-blue: #1669F2;

.google-btn {
  width: 100%;
  height: 42px;
  background-color: $google-blue;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: $white;
  }
  .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    width: 18px;
    height: 18px;
  }
  .btn-text {
    padding-left: 25px;
    padding-top: 13px;
    text-align: center;
    color: $white;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";

  }
  &:hover {
    box-shadow: 0 0 6px $google-blue;
  }
  &:active {
    background: $button-active-blue;
  }
}

@import url(https://fonts.googleapis.com/css?family=Roboto:500);


section.box .buttons {
  margin-top: 25px;
}

</style>
